export default function HowItsWorks() {
  return (
    <section className="sample-collection text-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="common-heading">
              <h2><span>Home sample collection </span> How It Works? </h2>
            </div>
            <br/>
          </div>
          <div className="col-lg-4">
            <div className="works-cunt">
              <span>1</span>
              <p>Search for the required  <br />tests/packages and  <br />book an appointment online.</p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="works-cunt">
              <span>2</span>
              <p>A certified Phlebotomist will reach your place on the chosen date and time to collect the sample.</p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="works-cunt blw-sml">
              <span>3</span>
              <p>The test reports will be  sent through mail or can be generated with your account from the Neuberg website.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
